import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  Provider,
} from '@angular/core';
import {
  AuthConfig as OAuthConfig,
  OAuthStorage,
  provideOAuthClient,
} from 'angular-oauth2-oidc';
import {
  AUTH_FEATURE_KEY,
  AuthEffects,
  authReducer,
} from '@lyceo/shared/auth/data-access';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { PrefixLocalStorage } from './prefix-local-storage';
import { AuthConfig, AUTH_CONFIG } from '@lyceo/shared/auth/util-models';

export function provideAuth(config: AuthConfig): EnvironmentProviders {
  const providers: (Provider | EnvironmentProviders)[] = [
    provideOAuthClient(config.authModuleConfig),
    { provide: AUTH_CONFIG, useValue: config },
    {
      provide: OAuthStorage,
      useClass: PrefixLocalStorage,
    },
    provideState(AUTH_FEATURE_KEY, authReducer),
    provideEffects(AuthEffects),
  ];

  if (config.oAuthConfig) {
    providers.push({ provide: OAuthConfig, useValue: config.oAuthConfig });
  }

  return makeEnvironmentProviders(providers);
}
